import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AbstractComponent } from '@spike/scaffolds';
import { Stepper, StepList, Step } from 'primeng/stepper'
import { WorkflowState } from '../../models/workflow-status.enum';
@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-workflow-stepper',
  providers:[],
  imports: [Stepper, StepList, Step],
  templateUrl: './workflow-stepper.html'
})
export class WorkflowStepperComponent extends AbstractComponent{
  stateId = input.required<number>();
  workflow = input.required<WorkflowState[]>();


  
}